import React, { useState, useEffect } from 'react';
import CustomTable from '../../../../customComponents/CustomTable';
import downloadIcon from './../../../../../Assets/icons/download.svg';
import './index.scss';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../../../services/api/API';
import ROUTES_NAVIGATION from '../../../../../routes/routes';
import {
  TABLE_HEADERS,
  keyMapping,
} from '../../../../../constants/WarrantyLists';
import SearchInput from '../../../../customComponents/CustomSearch/SearchInput';
import Loader from '../../../../customComponents/CustomLoader';

const Warranty = () => {
  const [tableData, setTableData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(true);
  const [totalData, setTotalData] = useState(0);
  const [totalActive, setTotalActive] = useState(0);
  const [totalInactive, setTotalInactive] = useState(0);

  const navigate = useNavigate();
  const token = localStorage.getItem('authToken');

  // useEffect(() => {
  //   fetchWarrantyData();
  // }, []);

  const fetchWarrantyData = async (page = 0, pageSize = 10) => {
    try {
      setLoading(true);
      const response = await axiosInstance.post(
        '/warranty/list',
        {
          orderBy: 'warranty_id desc',
          page,
          pageSize,
          searchText: searchTerm,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        warranty_type_desc: item.warranty_type_desc || '--',
        warranty_category_name: item.warranty_category_name || '--',
        'Sr No.': index + 1,
        warranty_replace_value: item.warranty_replace_value || '--',
      }));

      const totalRecordsData = response?.data?.data?.totalRecords;
      setTotalRecords(totalRecordsData);

      const totalCount = response?.data?.data?.total;
      const totalAct = response?.data?.data?.total_active;
      const totalInac = response?.data?.data?.total_inactive;

      if (searchTerm === '') {
        setTotalData(totalCount);
        setTotalActive(totalAct);
        setTotalInactive(totalInac);
      }

      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));

      console.log('response', response);
      setTableData(formattedData);
      // toastSuccess(" Data fetched successfully!");
    } catch (error) {
      console.error('Error fetching warranty list:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleEditButton = (rowData) => {
    navigate(`${ROUTES_NAVIGATION.WARRANTYEDIT}`, { state: { data: rowData } });
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchWarrantyData(newPage);
  };

  useEffect(() => {
    if (searchTerm === '') {
      fetchWarrantyData();
    }
  }, [searchTerm]);

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <div>
          <div className="OnboardManagamentContainer">
            <div className="OnboardManagamentbuttonContainer">
              <h5>Warranty</h5>
            </div>
            <div className="totalvaluescontainer col-xl-6 col-lg-12 mt-2 mb-2">
              <div
                className="topleftdataContainer"
                style={{ borderRight: '1px solid lightgrey' }}
              >
                <h5 className="listTopDataValueText">{totalData} </h5>
                <h6>All Warranty</h6>
              </div>
              <div
                className="topleftdataContainer"
                style={{ borderRight: '1px solid lightgrey' }}
              >
                <h5 className="listTopDataValueText">{totalActive} </h5>
                <h6>Active Warranty</h6>
              </div>
              <div className="topleftdataContainer">
                <h5 className="listTopDataValueText">{totalInactive} </h5>
                <h6>Inactive Warranty</h6>
              </div>
              <button
                className="addcustomerbutton"
                onClick={() => navigate(ROUTES_NAVIGATION.WARRANTYADD)}
              >
                Add Warranty
              </button>
            </div>
          </div>

          <div className="tableWrapper">
            <div className="admin-list-container">
              <div className="listsearchContainer">
                <h5>Warranty List</h5>
                <div>
                  <SearchInput
                    placeholder="Search Warranty Name"
                    onSearch={fetchWarrantyData}
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                  />
                </div>
              </div>
            </div>
            <CustomTable
              data={tableData}
              headers={TABLE_HEADERS}
              keyMapping={keyMapping}
              itemsPerPage={10}
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
              onEdit={handleEditButton}
              totalRecords={totalRecords}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Warranty;
